import { useCartContext } from "app/providers/CartProvider";
import { useMemo } from "react";
import { toast } from "react-toastify";
import { CategoryStandardProduct } from "shared/api/middleware-api-client";
import Button, { ButtonArrowTypes, ButtonTypes } from "shared/ui/button";
import Text from "shared/ui/typography/Text";
import { concatClassnames } from "shared/utils/concatClassnames";
import { getFormattedPrice } from "shared/utils/getFormattedPrice";
import { isDevelopmentEnvironment } from "../../../../shared/utils/checkEnvironment";
import { useAnalytics } from "app/hooks/shared/analytics/useAnalytics";

interface Props {
  className?: string;
  selectedSamples: CategoryStandardProduct[];
  setSelectedSamples: (sample: CategoryStandardProduct[]) => void;
}
const SamplesFooter = ({
  className,
  selectedSamples,
  setSelectedSamples,
}: Props) => {
  const { cart, getCart, updateCart } = useCartContext();
  const { onAddStandardProductToCart } = useAnalytics();
  const total = useMemo(() => {
    return selectedSamples.reduce(
      (total, sample) => (total += sample.price),
      0
    );
  }, [selectedSamples]);

  const onAddToCartClick = () => {
    if (cart.products.length) {
      toast.info(
        "Je kan geen kleurstalen toevoegen aan de winkelwagen, omdat je andere producttypes in de winkelwagen hebt zitten."
      );
      return;
    }

    if (selectedSamples.length) {
      const cartCopy = { ...getCart() };

      const newSamples = selectedSamples.map((sample) => {
        const newSample = {
          ...sample,
          amount: 1,
        };
        onAddStandardProductToCart(newSample);
        return newSample;
      });

      cartCopy.standardProducts = cartCopy.standardProducts.concat(newSamples);

      updateCart(cartCopy);

      setSelectedSamples([]);
      window.location.href = isDevelopmentEnvironment()
        ? "/webshop/checkout"
        : "/winkelwagen";
    } else {
      toast.error("U heeft nog geen kleurstalen geselecteerd");
    }
  };

  return (
    <footer className={concatClassnames("", className)}>
      <div className="gg-flex gg-justify-between gg-items-start">
        <div>
          <Text>Totaal</Text>
          <Text className="gg-text-2xl gg-font-bold">
            {getFormattedPrice(total)}
          </Text>
          <Text className="gg-hidden sm:gg-flex gg-text-xs gg-text-dark-blue-500 gg-mb-1">
            excl. €4,95 verzendkosten
          </Text>
          <Text className="gg-hidden sm:gg-flex gg-text-xs gg-text-dark-blue-500">
            Inclusief BTW
          </Text>
        </div>
        <Button
          type={ButtonTypes.YELLOW}
          className="gg-px-10 gg-py-4 disabled:gg-bg-grey-800"
          arrow={ButtonArrowTypes.RIGHT}
          onClick={() => onAddToCartClick()}
          disabled={selectedSamples.length === 0}
        >
          Naar winkelwagen
        </Button>
      </div>
      <Text className="gg-mt-2.5 sm:gg-mt-0 gg-text-right gg-text-sm gg-text-dark-blue-500">
        Verzendtijd: 3-5 werkdagen, <br /> Kleurstalen kunnen niet geretourneerd
        worden.
      </Text>
    </footer>
  );
};
export default SamplesFooter;
